import React from "react";
import { Handshake, Map, Search } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const advantages = [{
  title: "Medical Cessation",
  description: "When the FAA medical certificate is no longer an option, we transition your flight plan from the cockpit to a structured, high-level care environment at home.",
  icon: Handshake
}, {
  title: "Diagnosis Radar",
  description: "Early-stage cognitive or physical diagnoses require a technical response. We map out the asset-backed care logistics before the weather closes in.",
  icon: Map
}, {
  title: "Asset Gap Analysis",
  description: "Leveraging aircraft equity and airpark property values to fund a lifetime of private care, ensuring you never have to divert to a facility.",
  icon: Search
}];
export default function TheFourFlightConditions() {
  return <section data-section-id="223484" id="the-four-flight-conditions" className="w-full bg-background text-foreground py-20 md:py-28">
      <div className="container mx-auto px-4 md:px-6">
        <div className="rounded-md bg-secondary/20 border border-border/50 px-6 py-16 md:px-12 md:py-20 lg:px-16 backdrop-blur-sm">
          <div className="mx-auto mb-16 max-w-2xl text-center">
            <h2 className="font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl uppercase">
              The Four Flight Conditions
            </h2>
            <p className="mt-4 text-lg text-muted-foreground font-sans">
              Identifying the critical mission profiles that require a structured transition to long-term, in-home care.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            {advantages.map((item, i) => {
            const Icon = item.icon;
            return <Card key={i} data-index={i} className="group border border-border/40 bg-card/80 shadow-md transition-all duration-300 hover:border-primary hover:shadow-[0_0_20px_rgba(24,119,242,0.15)] rounded-md">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-md bg-primary/10 text-primary transition-transform duration-300 ease-out group-hover:-translate-y-2 border border-primary/20">
                      <Icon className="h-8 w-8 stroke-[1.5]" />
                    </div>
                    <CardTitle className="font-default text-xl font-bold uppercase tracking-tight">
                      <h3 className="font-mono text-primary text-sm mb-1 block">PROFILE_{i + 1}</h3>
                      <span className="font-default">{item.title}</span>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="leading-relaxed text-muted-foreground font-sans text-lg">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </div>
    </section>;
}